import React, { useEffect, useState, useCallback } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import CarbonTouch1 from "./CarbonTouch1";

const Gallery = ({ gallery, setExtended, index, setIndex, isMobile }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [swiper, setSwiper] = useState(null);
    const [isTooltipDismissed, setisTooltipDismissed] = useState(
        sessionStorage.getItem("isTooltipDismissed"),
    );

    useEffect(() => {
        const tooltipTimer = setTimeout(() => {
            sessionStorage.setItem("isTooltipDismissed", "true");
            setisTooltipDismissed("true");
        }, 10000);

        return () => {
            clearTimeout(tooltipTimer);
        };
    }, []);

    useEffect(() => {
        if (thumbsSwiper !== null && swiper !== null) {
            thumbsSwiper.update();
            swiper.update();
            swiper.slideTo(index, 0, false);
        }
    }, [index, thumbsSwiper, swiper]);

    const extendGallery = useCallback(() => {
        setExtended(true);
        setisTooltipDismissed("true");
        sessionStorage.setItem("isTooltipDismissed", "true");
    }, [setExtended]);

    return (
        <>
            {"true" !== isTooltipDismissed && false === isMobile && (
                <div className="tooltips">
                    <div className="OverlayGallery">
                        <CarbonTouch1 />
                        Cliquer pour agrandir la galerie
                    </div>
                </div>
            )}
            <div className="gallery">
                <Swiper
                    key={"SwiperPrincipal"}
                    style={{
                        "--swiper-navigation-color": "#fff",
                        "--swiper-pagination-color": "#fff",
                        "--swiper-navigation-size": "33px",
                    }}
                    spaceBetween={0}
                    navigation={!isMobile}
                    thumbs={{ swiper: thumbsSwiper }}
                    modules={[Navigation, Thumbs]}
                    loop={false}
                    className="mySwiper2"
                    onSlideChange={(swiper) => setIndex(swiper.activeIndex)}
                    onSwiper={setSwiper}
                >
                    {gallery.map((image) => {
                        let key1 = image.fileId;
                        return (
                            <SwiperSlide key={key1}>
                                <img
                                    onClick={() => {
                                        !isMobile && extendGallery();
                                    }}
                                    key={key1 + "img"}
                                    src={image.images.large}
                                    alt={image.alt}
                                />
                                {null !== image.alt && (
                                    <div className="complementsInfo">{image.alt}</div>
                                )}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <Swiper
                    key={"SwiperThumb"}
                    onSwiper={setThumbsSwiper}
                    loop={false}
                    spaceBetween={10}
                    slidesPerView={6}
                    watchSlidesProgress={true}
                    modules={[Navigation, Thumbs]}
                    className="mySwiper"
                >
                    {gallery.map((image) => {
                        let key2 = image.fileId + " Thumb";
                        return (
                            <SwiperSlide key={key2}>
                                <img
                                    key={key2}
                                    src={null === image.images.small ? image.images.large : image.images.small}
                                    alt={image.alt}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </>
    );
};

export default Gallery;
